export const I18N_CONFIG = {
  defaultLanguage: 'en',
  showLanguageSwitch: true,
};

